import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast mb-2 flex items-center group-[.toaster]:bg-krushr-info group-[.toaster]:text-white group-[.toaster]:border-0 group-[.toaster]:shadow-lg group-[.toaster]:rounded-lg",
          description: "group-[.toast]:text-white group-[.toast]:opacity-75",
          actionButton:
            "group-[.toast]:bg-white/20 group-[.toast]:text-white group-[.toast]:border group-[.toast]:border-white/40 group-[.toast]:hover:bg-white/30",
          cancelButton:
            "group-[.toast]:bg-transparent group-[.toast]:text-white/75 group-[.toast]:hover:text-white group-[.toast]:border-0",
          error: "group-[.toaster]:bg-krushr-secondary group-[.toaster]:text-white group-[.toaster]:border-0",
          success: "group-[.toaster]:bg-krushr-success group-[.toaster]:text-white group-[.toaster]:border-0",
          warning: "group-[.toaster]:bg-krushr-warning group-[.toaster]:text-white group-[.toaster]:border-0",
          info: "group-[.toaster]:bg-krushr-info group-[.toaster]:text-white group-[.toaster]:border-0",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
